import { render, staticRenderFns } from "./PdpProductPriceTooltip.vue?vue&type=template&id=8dd87dbe&"
import script from "./PdpProductPriceTooltip.vue?vue&type=script&lang=js&"
export * from "./PdpProductPriceTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports